import { makeStyles } from '@mui/styles';
import theme from 'src/theme';
export const useStyles = makeStyles(() => ({
  root: {
    background: theme.palette.common.white,
  },
}));
